import { Avatar, AvatarGroup, Tooltip } from "@mui/material";
import { getUserFullName } from "app/utils/appHelpers";
import config from '../../config';

function AvatarListGroup({ users }) {
    return (
        <AvatarGroup
            sx={{
                justifyContent: 'flex-start',
                alignItems: 'center',
                textAlign: 'left',
            }}
        >
            {users.map((n, index) =>
                n !== undefined ? (
                    <Tooltip key={index} title={getUserFullName(n)} placement="top">
                        <Avatar
                            style={{
                                backgroundColor: 'white',
                                color: '#757575',
                                border: `1px solid white`
                            }}
                            alt={n.name}
                            src={
                                n && n.profileImageUrl
                                    ? `${config.userAuthApiUrl}${n.profileImageUrl}`
                                    : undefined
                            }
                            onError={(e) => {
                                e.target.onerror = null;
                                e.target.src = config.userAuthApiUrl + config.defaultProfileImageUrl;
                            }}
                        />
                    </Tooltip>
                ) : (
                    <Tooltip key={index} title={"Bilinmeyen Kullanıcı"} placement="top">
                        <Avatar
                            style={{
                                backgroundColor: 'white',
                                color: '#757575',
                                border: `1px solid white`
                            }}
                        />
                    </Tooltip>
                )
            )}
        </AvatarGroup>
    );
}

export default AvatarListGroup;
